<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"/>
    <loading :loading="isLoading">
      <error :error="error"/>
      <b-tabs v-if="page">
        <b-tab title="Summary" active>
          <b-table striped :items="page.Summary">
            <template #head(Value)><div class="text-right">Value</div></template>
            <template #cell(Value)="data"><div class="text-right">{{ data.value }}</div></template>
          </b-table>    
        </b-tab>
        <b-tab title="Breakdown">
          <search :items="page.Breakdown" :showatonce="10">
            <template #results="data">
              <b-table striped :items="data.items">
                <template #head(# of Notifications)><div class="text-right"># of Notifications</div></template>
                <template #cell(# of Notifications)="data"><div class="text-right">{{ data.value | commas }}</div></template>
              </b-table>
            </template>
          </search>
        </b-tab>
      </b-tabs>
    </loading>
  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import Error from '../components/Error.vue'
import Search from '../components/Search.vue'

export default {
  components: { Loading, Error, Search },
  data() {
    return {
      isLoading: true,
      page: null,
      error: null,
      breadcrumbs: [
        { text: 'Statistics', to: '/' },
        { text: 'County-wide', active: true },
      ],
    };
  },
  mounted() {
    this.isLoading = true;
    const { access_token } = this.$store.state.oidcStore;
    return this.$reportingApi.renderPage('panessex', access_token, {
      pageName: 'StatsCounty',
    })
    .then((page) => { this.page = page; this.isLoading = false; })
    .catch(e => { this.error = e.message; this.isLoading = false; });
  },
};
</script>
